import { render, staticRenderFns } from "./Logistic.vue?vue&type=template&id=b7d98172&scoped=true&"
import script from "./Logistic.vue?vue&type=script&lang=js&"
export * from "./Logistic.vue?vue&type=script&lang=js&"
import style0 from "./Logistic.vue?vue&type=style&index=0&id=b7d98172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d98172",
  null
  
)

export default component.exports